import React from 'react';
import moment from "moment";
import {
  Row, Col} from 'antd';
import img from './../../assets/img/freepik  Plant  inject 2@3x.png';
const TierProfile = (props) => {
  return (
    <div className="mi_model_popup">
      <Row span={24}>
        <Col span={18}>
          <p className='mi_title' style={{marginBottom:'25px'}}>{props.title}
          </p>
        </Col>
        <Col span={6}>
          <i className="fa fa-times mi_icon mi_icon_red mi_button_close" style={{ color: 'red' }} onClick={props.closeDrawerHandler} ></i>
        </Col>
      </Row>
      <Row span={24}>
        <Col md={8} sm={12} >
          <p className="mi_name_pro">Plan Name</p>
          <p className="mi_value_pro">{props.Client_Tier.plan_Name}</p>
        </Col>
        <Col md={8} sm={12} >
          <p className="mi_name_pro">Plan Id</p>
          <p className="mi_value_pro">{props.Client_Tier.client_plan_Id}</p>
        </Col>
        <Col md={8} sm={12} >
          <p className="mi_name_pro">LOA</p>
          <p className="mi_value_pro">{props.Client_Tier.lob_name?props.Client_Tier.lob_name:"none"}</p>
        </Col>
        <Col md={8} sm={12} >
          <p className="mi_name_pro">Unit of Measure</p>
          <p className="mi_value_pro">{props.Client_Tier.uom_Name}</p>
        </Col>
        <Col md={8} sm={12} >
          <p className="mi_name_pro">Start Date</p>
          <p className="mi_value_pro">{moment(props.Client_Tier.start_date).format("MM/DD/YYYY")}</p>
        </Col>
        <Col md={8} sm={12} >
          <p className="mi_name_pro">End Date</p>
          <p className="mi_value_pro">{moment(props.Client_Tier.end_date).format("MM/DD/YYYY")}</p>
        </Col>
        <Col md={8} sm={12} >
          <p className="mi_name_pro">Profile Name</p>
          <p className="mi_value_pro">{props.Tier_Profile.tier_profile_name}  </p>
        </Col>
        <Col md={8} sm={12} >
          <p className="mi_name_pro">Reimbursement Type</p>
          <p className="mi_value_pro">{props.Tier_Profile.reimb_type_name}</p>
        </Col>
        <Col md={8} sm={12} >
          <p className="mi_name_pro">Qualifier</p>
          <p className="mi_value_pro">{props.Tier_Profile.qualifier_value}</p>
        </Col>
        <Col md={8} sm={12} >
          <p className="mi_name_pro">Renewal</p>
          <p className="mi_value_pro">{props.Tier_Profile.new_add_renewal
            ? "No"
            : "Yes"}</p>
        </Col>
        <Col md={8} sm={12} >
          <p className="mi_name_pro">Min Allowance</p>
          <p className="mi_value_pro">{props.Tier_Profile.min_allow}</p>
        </Col>
        <Col md={8} sm={12} >
          <p className="mi_name_pro">Max Allowance</p>
          <p className="mi_value_pro">{props.Tier_Profile.max_allow}</p>
        </Col>
        <Col md={8} sm={12} >
          <p className="mi_name_pro">Calculation Method</p>
          <p className="mi_value_pro">{props.Tier_Profile.reimb_cal_meth ? "Percentage" : "Fixed"}</p>
        </Col>
        <Col md={8} sm={12} >
          <p className="mi_name_pro">Profile Start Date</p>
          <p className="mi_value_pro">{moment(props.Tier_Profile.start_date).format("MM/DD/YYYY")}</p>
        </Col>
        <Col md={8} sm={12} >
          <p className="mi_name_pro">Profile End Date</p>
          <p className="mi_value_pro">{moment(props.Tier_Profile.end_date).format("MM/DD/YYYY")}</p>
        </Col>
        <Col md={8} sm={12} >
          <p className="mi_name_pro">IsRate</p>
          <p className="mi_value_pro">{props.Client_Tier.is_rate?"Yes":"No"}</p>
        </Col>
        <Col md={8} sm={12} >
          <p className="mi_name_pro">Commission Process</p>
          <p className="mi_value_pro">{props.Client_Tier.commission_Process}</p>
        </Col>
        <Col md={8} sm={12} >
          <p className="mi_name_pro">Commission Recovery Period</p>
          <p className="mi_value_pro">{props.Client_Tier.commission_Recovery_Period+" Days"}</p>
        </Col>
        {/* <Col md={8} sm={12} >
          <p className="mi_name_pro">Broker of Record</p>
          <p className="mi_value_pro">{props.Client_Tier.bor}</p>
        </Col> */}
      </Row>
      <Row span={24}>
        <ul style={{listStyle:'none',padding:'0px',display:'flex'}}>
          <li style={{marginRight:'15px'}}>
          <p className="mi_name_pro" style={{marginBottom:'10px'}}>Range</p>
          <p className="mi_value_pro">Commission</p>
          </li>
          <li style={{marginRight:'15px'}}>
          <p className="mi_name_pro" style={{marginBottom:'10px'}}>{props.Client_Tier.tier1}</p>
          <p className="mi_value_pro">{props.Tier_Profile.tier1}</p>
          </li>
          <li style={{marginRight:'15px'}}>
          <p className="mi_name_pro" style={{marginBottom:'10px'}}>{props.Client_Tier.tier2 ? props.Client_Tier.tier2 : ''}</p>
          <p className="mi_value_pro">{props.Tier_Profile.tier2 ? props.Tier_Profile.tier2 : ""}</p>
          </li >
          <li style={{marginRight:'15px'}}>
          <p className="mi_name_pro" style={{marginBottom:'10px'}}>{props.Client_Tier.tier3 ? props.Client_Tier.tier3 : ''}</p>
          <p className="mi_value_pro">{props.Tier_Profile.tier3 ? props.Tier_Profile.tier3 : ""}</p>
          </li>
          <li style={{marginRight:'15px'}}>
          <p className="mi_name_pro" style={{marginBottom:'10px'}}>{props.Client_Tier.tier4 ? props.Client_Tier.tier4 : ''}</p>
          <p className="mi_value_pro">{props.Tier_Profile.tier4 ? props.Tier_Profile.tier4 : ""}</p>
          </li>
          <li style={{marginRight:'15px'}}>
          <p className="mi_name_pro" style={{marginBottom:'10px'}}>{props.Client_Tier.tier5 ? props.Client_Tier.tier5 : ''}</p>
          <p className="mi_value_pro">{props.Tier_Profile.tier5 ? props.Tier_Profile.tier5 : ""}</p>
          </li>
          <li style={{marginRight:'15px'}}>
          <p className="mi_name_pro" style={{marginBottom:'10px'}}>{props.Client_Tier.tier6 ? props.Client_Tier.tier6 : ''}</p>
          <p className="mi_value_pro">{props.Tier_Profile.tier6 ? props.Tier_Profile.tier6 : ""}</p>
          </li>
          <li style={{marginRight:'15px'}}>
          <p className="mi_name_pro" style={{marginBottom:'10px'}}>{props.Client_Tier.tier7 ? props.Client_Tier.tier7 : ''}</p>
          <p className="mi_value_pro">{props.Tier_Profile.tier7 ? props.Tier_Profile.tier7 : ""}</p>
          </li>
          <li style={{marginRight:'15px'}}>
          <p className="mi_name_pro" style={{marginBottom:'10px'}}>{props.Client_Tier.tier8 ? props.Client_Tier.tier8 : ''}</p>
          <p className="mi_value_pro">{props.Tier_Profile.tier8 ? props.Tier_Profile.tier8 : ""}</p>
          </li>
          <li style={{marginRight:'15px'}}>
          <p className="mi_name_pro" style={{marginBottom:'10px'}}>{props.Client_Tier.tier9 ? props.Client_Tier.tier9 : ''}</p>
          <p className="mi_value_pro">{props.Tier_Profile.tier9 ? props.Tier_Profile.tier9 : ""}</p>
          </li>
          <li style={{marginRight:'15px'}}>
          <p className="mi_name_pro" style={{marginBottom:'10px'}}>{props.Client_Tier.tier10 ? props.Client_Tier.tier10 : ''}</p>
          <p className="mi_value_pro">{props.Tier_Profile.tier10 ? props.Tier_Profile.tier10 : ""}</p>
          </li>
        </ul>
      </Row>
      <Row>
      <img alt="example" style={{ height: '80px', marginBottom: '-28px', float: 'right' }} src={img} />
      </Row>
     </div>
  )
}
export default TierProfile;